const navigators = [
  {
    name: '我的危机',
    key: 'MyCase',
    url: '/user/case'
  },
  {
    name: '我的报告',
    key: 'MyReport',
    url: '/user/report'
  },
  {
    name: '账号权限',
    key: 'MyVip',
    url: '/user/vip'
  },
  {
    name: '账号管理',
    key: 'MyInformation',
    url: '/user/information'
  }
  // {
  //   name: '个人信息',
  //   key: 'MyInformation',
  //   url: '/user/information'
  // },
  // {
  //   name: '我的VIP',
  //   key: 'OpenVip',
  //   url: '/user/vip'
  // },
  // {
  //   name: '我的定制',
  //   key: 'MyReport',
  //   url: '/user/report'
  // },
  // {
  //   name: '收藏/订阅',
  //   key: 'MyCollect',
  //   url: '/user/collect'
  // },
  // {
  //   name: '我的消息',
  //   key: 'MyMessage',
  //   url: '/user/messgae'
  // }
  // {
  //   name: '报告定制',
  //   key: 'ReportCustomMade',
  //   url: '/user/reportmade'
  // },
  // {
  //   name: '发票管理',
  //   key: 'BillManager',
  //   url: '/user/bill'
  // },
  // {
  //   name: '小工具',
  //   key: 'MiniTools',
  //   url: '/user/tools'
  // }
]

const navigatorsLeft = [
  {
    name: '个人信息',
    key: 'MyInformation',
    url: '/user/information'
  },
  // {
  //   name: '我的VIP',
  //   key: 'OpenVip',
  //   url: '/user/vip'
  // },
  // {
  //   name: '我的定制',
  //   key: 'MyReport',
  //   url: '/user/report'
  // },
  {
    name: '收藏/订阅',
    key: 'MyCollect',
    url: '/user/collect'
  },
  {
    name: '我的消息',
    key: 'MyMessage',
    url: '/user/messgae'
  }
]

const eventNavigators = [
  {
    name: '危机概览',
    key: 'EventGeneral',
    auth: false
  },
  {
    name: '传播趋势',
    key: 'EventTendency',
    auth: true
  },
  {
    name: '渠道分布',
    key: 'EventChannel',
    auth: true
  },
  {
    name: '观点分布',
    key: 'EventViews',
    auth: true
  },
  {
    name: '回应明细',
    key: 'EventResponse',
    auth: true
  }
]

const crisisNavigators = [
  {
    name: '首页',
    key: 'EventIndex',
    class: 'fa  fa-home',
    active: true
  },
  {
    name: '危机库',
    key: 'CaseCollection',
    class: 'fa  fa-list-ul',
    active: false
  },
  // {
  //   name: '危机榜单',
  //   key: 'CrisisRank',// 在router中也隐藏了
  //   class: 'fa  fa-bar-chart',
  //   active: false
  // },
  {
    name: '危机图谱',
    key: 'CrisisChart',
    class: 'fa fa-share-alt',
    active: false
  },
  // {
  //   name: '危机洞察',
  //   key: 'CrisisInsight',
  //   class: 'fa  fa-vimeo',
  //   active: false
  // },
  // {
  //   name: '案例对比',
  //   key: 'CaseCompare',
  //   class: 'fa  fa-vimeo',
  //   active: false
  // },
  {
    name: '危机报告',
    key: 'ReportDownload',
    class: 'fa  fa-cloud-download',
    active: false
  }
]

const headerNavs = [
  {
    name: '官网',
    url: 'http://zhiweidata.com',
    mode: 'outer',
    type: 'link',
    loginRequired: false,
    vipRequired: false
  },
  {
    name: '产品',
    url: '',
    type: 'list',
    loginRequired: false,
    vipRequired: false,
    lists: [
      {
        name: '知微传播分析',
        mode: 'outer',
        url: 'http://weiboreach.com/'
      },
      {
        name: '知微事见',
        mode: 'outer',
        url: 'http://ef.zhiweidata.com/#!/index'
      }
    ]
  },
  {
    name: '全部事件',
    url: 'EventAll',
    mode: 'inner',
    type: 'link',
    loginRequired: true,
    vipRequired: false
  }
  // {
  //   name: '需求定制',
  //   url: '',
  //   type: 'list',
  //   loginRequired: true,
  //   vipRequired: false,
  //   lists: [
  //     {
  //       name: '报告定制',
  //       mode: 'inner',
  //       url: 'ReportCustomMade'
  //     },
  //     {
  //       name: '链路图定制',
  //       mode: 'inner',
  //       url: 'MiniTools'
  //     }
  //   ]
  // }
  // {
  //   name: '发票管理',
  //   url: 'BillManager',
  //   type: 'link',
  //   mode: 'inner',
  //   loginRequired: true,
  //   vipRequired: true
  // }
]

const eventType = [

]

const pricingPackage = [
  {
    month: 1,
    case: 3,
    money: 2200,
    discount: 0,
    active: true,
    type: 1
  },
  {
    month: 3,
    case: 5,
    money: 6000,
    discount: 0,
    active: false,
    type: 2
  },
  {
    month: 6,
    case: 7,
    money: 12000,
    discount: 85,
    active: false,
    type: 3
  },
  {
    month: 12,
    case: Infinity,
    money: 20000,
    discount: 75,
    active: false,
    type: 4
  }
]

const introduceModules = [
  {
    name: '传播效果',
    modules: [
      '宏观传播指标',
      '事件传播趋势图',
      '事件传播脉络',
      '微博关键传播节点'
    ]
  },
  {
    name: '舆论聚焦',
    modules: [
      '微博账号阵营分布',
      '微博主要传播方向',
      '网媒渠道阵营分布',
      '网媒主要传播方向',
      '微信主要传播方向'
    ]
  },
  {
    name: '人群画像',
    modules: [
      '地域分布',
      '性别分布',
      '发粉丝数分布',
      '认证类型分布'
    ]
  }
]

const addedModules = [
  {
    name: '网民评论分析',
    introduce: '筛选出互动量TOP5的微博，对其热门评论进行采集分析',
    expense: '微博网民评论分析300元',
    html: '微博网民评论分析<span>¥300</span>',
    cost: 300,
    val: 1,
    active: false
  },
  {
    name: '关键微博传播链路',
    introduce: '挑选事件中的关键微博（不多于5个），输出微博传播链路图',
    expense: '关键微博传播链路500元',
    html: '关键微博传播链路<span>¥500</span>',
    val: 2,
    cost: 500,
    active: false
  },
  {
    name: '单条微博传播链路',
    introduce: '选择单条微博，根据其转发关系绘制传播链路图',
    expense: '单条微博传播链路300元',
    html: '单条微博传播链路<span>¥300</span>',
    val: 3,
    cost: 300,
    active: false
  },
  {
    name: '情感倾向标注',
    introduce: '数据量超过3k时，情感倾向标注按小时做抽样标注；数据量未满3k，则全部标注',
    expense: '情感倾向标注600元',
    html: '情感倾向标注<span>¥600</span>',
    val: 4,
    cost: 600,
    active: false
  },
  {
    name: '高阅读公众号分析',
    introduce: '采集公众号阅读与点赞量，选取TOP10的公众号文章进行分析',
    expense: '高阅读公众号分析300元',
    html: '高阅读公众号分析<span>¥300</span>',
    val: 5,
    cost: 300,
    active: false
  }
]

const finshTimeOptions = [
  {
    name: '3个工作日',
    recommend: false,
    expense: '3工作日完成800元',
    html: '3工作日完成<span>¥800</span>',
    cost: 800,
    value: 3,
    active: false
  },
  {
    name: '5个工作日',
    recommend: true,
    expense: '5工作日完成500元',
    html: '5工作日完成<span>¥500</span>',
    cost: 500,
    value: 5,
    active: true
  },
  {
    name: '7个工作日',
    recommend: false,
    expense: '7工作日完成0元',
    html: '7工作日完成<span>¥0</span>',
    cost: 0,
    value: 7,
    active: false
  }
]

const positions = [
  '计算机/互联网/通信',
  '公关',
  '生产/工艺/制造',
  '医疗/护理/制药',
  '金融/银行/投资/保险',
  '商业/服务业/个体经营',
  '文化/广告/传媒',
  '娱乐/艺术/表演',
  '律师/法务',
  '教育/培训',
  '公务员/行政/事业单位',
  '学生',
  '其他',
  '--'
]

const venationsConfig = ['未选择', '其他品牌', '当事人', '重要媒体', '重要自媒体', '政务机构', '涉事品牌']

const getStar = (level) => {
  let star = ``
  for (let j = 0; j < level; j++) {
    star = star + '<i class="fa fa-star"></i>'
  }
  for (let k = 5; k > level; k--) {
    star = star + '<i class="fa fa-star-o"></i>'
  }
  return star
}

const toThousands = (n) => {
  if (n === undefined) return 0
  return (n).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
}

const parseUrl = (url) => {
  if (!url) {
    return url
  }
  return url.indexOf('http') !== -1 ? url : `http://${url}`
}

const ctxSplit = (ctx, len) => {
  if (!ctx || typeof (ctx) !== 'string' || ctx.length < len) {
    return ctx
  }
  let sub = []
  for (let i = 0; i < ctx.length / len; i++) {
    sub.push(ctx.substring(i * len, (i + 1) * len))
  }
  return sub.join('\n')
}

export {
  eventType,
  navigators,
  navigatorsLeft,
  eventNavigators,
  headerNavs,
  pricingPackage,
  introduceModules,
  addedModules,
  finshTimeOptions,
  positions,
  crisisNavigators,
  venationsConfig,
  getStar,
  toThousands,
  parseUrl,
  ctxSplit
}



// WEBPACK FOOTER //
// ./src/pages/index/config/config.js